'use client'

import { useState } from 'react'

export const useTogglePassword = () => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)
  const togglePasswordVisibility = () => setIsPasswordVisible(state => !state)

  return { isPasswordVisible, togglePasswordVisibility }
}
